/**
 * Created by fers on 26.09.15.
 */

import { declareEntity } from '../fw/MetaDataHelper';
import { v4 as uuidv4 } from 'uuid';
import * as Permission from '../util/Permission';
import {RuleTypes} from './ScenarioChannelDefRuleType';

export default declareEntity({
    entity: 'scenarios2ChannelDefs',
    graphQL: "Scenarios2ChannelDef",
    name: "Scenario to Application Definition",
    writePermission: [
        Permission.PERM_EDIT_CHANNEL_DEF
    ],
    dynamoPrefix: 'def',
    storageType: 'schema',
    parentRelation: "scenarios2ChannelDefs",
    isPublic: true,
	defaultOrder: ['key', 'channelDef_id'],
    onModify: ['scenarioDef'],
    fields: (types) => {
        return {
            id: {
                name: "Rule ID",
                type: "id",
                primaryKey: true,
                required: true,
                compositeKey: true,
                userEditable: false,
                defaultValue: () => {
                    return uuidv4();
                },
                isPublic: true,
            },
            scenario: {
                name: "Scenario",
                to: () => types['scenarios'],
                type: "relation",
                required: true,
                parent: true,
                compositeKey: true,
                hiddenCreate: true,
                defaultValue: (scenario) => {
                    return scenario['id'];
                },
                isPublic: true,
            },
            key: {
                name: "Key",
                type: "string",
                defaultValue: "",
                isPublic: true,
            },
            ruleType: {
                name: "Rule Type",
                type:  "enum",
                defaultValue: "inserted",
                values: RuleTypes,
                isPublic: true,
            },
            channelDef: {
                name: "Application Definition",
                to: () => types['channelDefs'],
                type: "relation",
                required: true,
                isPublic: true,
            },
            scenarioDef: {
                name: "Scenario Definition",
                to: () => types['scenarioDefs'],
                type: "relation",
                required: true,
                isPublic: true,
            },
            doNotShowToUser: {
                name: "Do not show to user",
                type: "boolean",
                defaultValue: false,
                isPublic: true,
            },
            requiresCaching: {
                name: "Requires activated caching",
                type: "boolean",
                defaultValue: false,
                isPublic: true,
            },
            requiresWritePermission: {
                name: "Requires write permission for API",
                type: "boolean",
                defaultValue: false,
                isPublic: true,
            },
            order: {
				name: "Order",
				type: "int",
				defaultValue: 0,
				required: false,
				isPublic: true,
			},
        };
    }
});
